import { mockMessageA } from './mockMessageA'
import { MOCK_MESSAGE_A_ID } from './mockMessagesConstants'
import { MessagesReducer } from 'state/reducers/types/MessagesReducer'

export const mockMessages: MessagesReducer = {
  [MOCK_MESSAGE_A_ID]: mockMessageA,
}
